import { Link } from 'react-router-dom';

// material-ui
import { Grid, Stack, Typography } from '@mui/material';

// project import
import BaseWrapper from './BaseWrapper';
import VerificationCode from 'components/@extended/VerificationCode';
import CodeVerificator from 'components/@extended/CodeVerificator';
import CenteredFeedbackContainer from 'components/@ui/feedback/CenteredFeedbackContainer';
import Overlay from 'components/@ui/overlay/Overlay';
import Feedback from 'components/@ui/feedback/Feedback';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { resetVerificationStatus } from 'store/reducers/account';
import { useNavigate } from 'react-router';

// ================================|| LOGIN ||================================ //

const SuccessPage = () => {
  const { isVerifying, isVerified, errorMessage, isError } = useSelector((state) => state.account);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (isError || isVerified) {
      // Automatically reset feedback status after a short delay
      const timer = setTimeout(() => {
        // dispatch(resetStore());
        dispatch(resetVerificationStatus());
        isVerified && navigate('/login');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [isVerified, isError, dispatch]);

  return (
    <>
      <BaseWrapper>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
              <Typography variant="h3" className="inline-flex tracking-wide">
                Welcome to{' '}
                <span style={{ textDecoration: 'underline', color: '#00B1E7', marginLeft: '6px' }}>
                  <a href="/login">Priseen.</a>
                </span>
              </Typography>
              {/* <Typography component={Link} to="/login" variant="body1" sx={{ textDecoration: 'none' }} color="primary">
           Go to login page
          </Typography> */}
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" sx={{ fontWeight: '500', fontSize: '18px' }}>
              Your account has been created successfully! Kindly enter the verification code sent on your email address.
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <VerificationCode />
            {/* <CodeVerificator /> */}
          </Grid>
        </Grid>
      </BaseWrapper>
      <Overlay sx={{ backdropFilter: 'blur(1px)', alignItems: 'start' }} visible={isVerified || isVerifying || isError ? true : false}>
        <CenteredFeedbackContainer>
          {isVerifying && <Feedback feedback={'Verifying Account'} type="loading" />}
          {isVerified && <Feedback feedback={'Account Verification Successfull'} type="success" />}
          {isError && <Feedback feedback={'There was a problem verifying your account. '} type="error" />}
        </CenteredFeedbackContainer>
      </Overlay>
    </>
  );
};

export default SuccessPage;
